var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.85 0.299988C9.97483 0.299988 9.13547 0.647665 8.5166 1.26654C7.89773 1.88541 7.55005 2.72477 7.55005 3.59999V16.8C7.55005 17.6752 7.89773 18.5146 8.5166 19.1334C9.13547 19.7523 9.97483 20.1 10.85 20.1H20.75C21.6253 20.1 22.4646 19.7523 23.0835 19.1334C23.7024 18.5146 24.05 17.6752 24.05 16.8V7.58309C24.0499 6.70794 23.7021 5.86871 23.0831 5.24999L19.1 1.26689C18.4813 0.647975 17.6421 0.300175 16.7669 0.299988H10.85Z",
    fill: "#9FB3C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.949951 10.2C0.949951 9.32481 1.29763 8.48544 1.9165 7.86657C2.53537 7.2477 3.37474 6.90002 4.24995 6.90002V23.4H17.45C17.45 24.2752 17.1023 25.1146 16.4834 25.7335C15.8645 26.3523 15.0252 26.7 14.15 26.7H4.24995C3.37474 26.7 2.53537 26.3523 1.9165 25.7335C1.29763 25.1146 0.949951 24.2752 0.949951 23.4V10.2Z",
    fill: "#9FB3C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.a06cec5c00ba3a77e5a469f18e649316.svg";
export { ForwardRef as ReactComponent };